export enum HotspotTypeEnum {
  Circle = 'circle',
  CirclePlus = 'circle-plus',
  CircleMinus = 'circle-minus',
  Label = 'label',
  CircleLabel = 'circle-label'
}
